import { createContext, useContext } from 'react';
import { initialState } from './User.constants';
import { tUserContext } from './User.types';

export const UserContext = createContext<tUserContext>(initialState);

export function useUserContext(): tUserContext {
  return useContext(UserContext);
}
